import { render } from "./GalleryItemLoaderComponent.vue?vue&type=template&id=97e86456&ts=true"
import script from "./GalleryItemLoaderComponent.vue?vue&type=script&lang=ts"
export * from "./GalleryItemLoaderComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__